import styled from 'styled-components';
import { dimensions, colors, typography } from 'modules/common/styles';
import { BoxRoot } from 'modules/common/styles/main';

const rowTitleSize = 230;
const boxSize = 125;
const boxSize1 = 140;
const columnTitleSize = 300;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${dimensions.coreSpacing}px;
`;

// const RowTitle = styled.h3`
//   font-size: ${typography.fontSizeHeading8}px;
//   font-weight: ${typography.fontWeightMedium};
//   padding: 0 ${dimensions.coreSpacing * 2}px;
//   text-transform: uppercase;
//   margin: ${dimensions.coreSpacing}px 0;
//   color: ${colors.colorCoreDarkGray};
//   flex-shrink: 0;
//   align-self: center;
//   width: ${rowTitleSize}px;
// `;

const RowTitle = styled.h3`
  font-size: ${typography.fontSizeHeading8 + 1}px;
  font-weight: ${typography.fontWeightMedium};
  text-transform: uppercase;
  margin: 0 0 ${dimensions.coreSpacing}px;
  color: ${colors.colorCoreDarkGray};
  flex-shrink: 0;
  align-self: center;
  width: ${columnTitleSize}px;

  > span {
    text-transform: initial;
    display: block;
    color: ${colors.colorCoreGray};
    margin-top: ${dimensions.unitSpacing - 5}px;
    font-weight: normal;
    max-width: ${columnTitleSize - 40}px;
    line-height: 1.4;
  }

  @media (max-width: 1170px) {
    align-self: flex-start;
  }
`;

const Box = styled(BoxRoot)`
  width: ${boxSize + dimensions.coreSpacing}px;
  height: ${boxSize}px;
  border-color: transparent;
  background: ${colors.colorWhite};
  position: relative;

  img {
    height: 35px;
    width: 35px;
    margin-top: 8px;
  }

  > a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    > em {
      background: ${colors.colorCoreGreen};
      border-radius: 3px;
      color: #fff;
      font-size: 11px;
      font-weight: 600;
      padding: 0 ${dimensions.unitSpacing - 5}px;
      position: absolute;
      right: ${dimensions.unitSpacing - 5}px;
      top: ${dimensions.unitSpacing - 5}px;
      text-transform: uppercase;
    }

    &:focus {
      text-decoration: none;
    }
  }

  &.hasBorder {
    border-bottom: ${dimensions.unitSpacing - 7}px solid
      ${colors.colorCoreGreen};
  }

  &:hover {
    img {
      transform: scale(1.1) rotate(4deg);
    }
  }
`;

// const Box = BoxRoot.extend`
//   width: ${boxSize1}px;
//   height: ${boxSize}px;

//   .autolink {
//     display: flex;
//     flex-direction: column;
//     -webkit-box-align: center;
//     align-items: center;
//     -webkit-box-pack: justify;
//     justify-content: space-between;
//     height: 100%;
//   }

//   img {
//     width: 30px;
//     margin-top: 15px;
//   }
// `;

const Divider = styled.div`
  border-bottom: 1px dotted ${colors.borderDarker};
  padding-bottom: ${dimensions.coreSpacing}px;
  margin-bottom: ${dimensions.coreSpacing}px;
  margin-left: ${rowTitleSize}px;
`;

const BoxName = styled.span`
  color: ${colors.colorBlack};
  display: block;
  margin-top: ${dimensions.unitSpacing}px;
  font-size: 12px;
  font-weight: 500;
`;

export { Row, RowTitle, Box, Divider, BoxName };



// WEBPACK FOOTER //
// src/modules/screens/settings/main/styles.js